import React, { useEffect, useMemo, useState } from 'react'
import './appcustom.scss'
import cx from 'classnames';
import {  useSelector } from 'react-redux';
import { Editor } from './editor/editor';
import { ISettings,  } from './redux/reducers/settings';
import { ControlPanel } from './controlpanel';



export const CustomTheme = React.createContext('');


export function AppCustom({ styleToApply, version }: { styleToApply: string, version:any }) {

    const product = useSelector((state: any) => state.product)
    let stepSize = useSelector((state: any) => state.fbdata?.fabricUnitSizeCm);
    stepSize = useSelector((state:any)=> state.settings?.configuration?.stepSize)||stepSize
    const [scenDims, setScenDims] = useState({ width: 0, height: 0 })

    const parts: any[] = useSelector((state: any) => state.parts)
    const activePart = useMemo(() => { return parts.find(part => part.active) }, [parts])

    const [partLength, setPartLength] = useState(stepSize);
    useEffect(() => { setPartLength(stepSize) }, [stepSize]);
    const rulerUnits = useSelector((state: any) => state.settings.rulerUnits);
    const fabricLength = useSelector((state: any) => (state.settings as ISettings)?.display?.currentLength)
    const appver = version;
    return product && stepSize ? <CustomTheme.Provider value={styleToApply || 'default-style'}>
        <div className={cx(styleToApply || 'default-style', 'app-container')}>
        <div className='control-panel'>
                <ControlPanel
                    partId={activePart?._id}
                    scenDimensions={scenDims}
                    stepSize={stepSize} activePart={activePart} fabricMaxLength={product.totalLength} fabricWidth={product.width} fabricLength={fabricLength || stepSize} />
        </div>
        <div className='editor'>
                <Editor onScenDimensionsUpdated={setScenDims} appVersion={appver} activePart={activePart} maxLength={product.totalLength} partLength={fabricLength || stepSize} partId={activePart?._id} fabricWidth={product.width} partSize={partLength || stepSize} stepSize={stepSize} noOfParts={rulerUnits} />
        </div>
        </div>
    </CustomTheme.Provider> : null

}

//export const CanvasGrid = React.createContext({ rows: 0, columns: 0 })


